import styled from "styled-components";

export const SurveyManagementPageStyled = styled.div`
  height: 100vh;
  height: 100dvh;
  overflow: hidden;

  display: flex;
  flex-direction: column;
`;
